module.exports = __webpack_public_path__ + "files/cf50a6182be365933423e5f6c70295cc.png";